(function () {
  document.addEventListener('DOMContentLoaded', function () {

    // Helper to find the nearest product image based on specific containers
    function findNearestImage(element) {
      let currentElement = element;
      // Traverse up to find the container
      for (let i = 0; i < 10; i++) { // Increased depth just in case
        if (!currentElement) break;

        // Check for Product Page Gallery
        const gallery = currentElement.querySelector('.product__media-gallery');
        if (gallery) {
          const img = gallery.querySelector('img');
          if (img) return img;
        }

        // Check for Product Card Thumbnail
        const thumbnail = currentElement.querySelector('.product__card__thumbnail');
        if (thumbnail) {
          const img = thumbnail.querySelector('img');
          if (img) return img;
        }

        // Also check if the current element IS the container (in case we are inside it)
        if (currentElement.classList.contains('product__media-gallery')) {
          const img = currentElement.querySelector('img');
          if (img) return img;
        }
        if (currentElement.classList.contains('product__card__thumbnail')) {
          const img = currentElement.querySelector('img');
          if (img) return img;
        }

        currentElement = currentElement.parentElement;
      }

      // Fallback: Try to find these containers globally if not found relative to button (e.g. sticky add to cart)
      // But prioritize the one related to the button if possible.
      // If we are on a product page, .product__media-gallery might be outside the form container.
      const mainGallery = document.querySelector('.product__media-gallery img');
      if (mainGallery) return mainGallery;

      return null;
    }

    // Main click handler attached to body for delegation
    document.body.addEventListener('click', function (e) {
      if (!window.flyToCartConfig || !window.flyToCartConfig.enable) return;

      // Check if the clicked element is or is inside one of the target buttons
      const target = e.target.closest("button[name='add'], .product__card__actions__btn--cart");

      if (!target) return;

      // Target: Top-right corner of the viewport
      const endRect = {
        left: window.innerWidth - 415, // 30px from right
        top: 110, // 20px from top
        width: 30,
        height: 30
      };

      const productImage = findNearestImage(target);
      if (!productImage) return;

      // Configuration
      const animationStyle = window.flyToCartConfig.animation || 'ease-out';
      const animationPath = window.flyToCartConfig.path || 'direct';
      const duration = (window.flyToCartConfig.duration || 1.0) * 1000;
      const opacity = window.flyToCartConfig.opacity || 0.8;

      // Clone and setup
      const clone = productImage.cloneNode(true);
      const startRect = productImage.getBoundingClientRect();

      clone.style.position = 'fixed';
      clone.style.top = startRect.top + 'px';
      clone.style.left = startRect.left + 'px';
      clone.style.width = startRect.width + 'px';
      clone.style.height = startRect.height + 'px';
      clone.style.zIndex = '9999';
      clone.style.pointerEvents = 'none';
      clone.style.margin = '0';

      document.body.appendChild(clone);

      // WAAPI Keyframes
      let keyframes = [];
      const steps = 30;

      const lerp = (start, end, t) => start * (1 - t) + end * t;

      for (let i = 0; i <= steps; i++) {
        const t = i / steps;
        let x = lerp(startRect.left, endRect.left, t);
        let y = lerp(startRect.top, endRect.top, t);

        if (animationPath === 'zigzag') {
          const zigzagAmplitude = 50;
          const zigzagFrequency = 3;
          const offset = Math.sin(t * Math.PI * zigzagFrequency) * zigzagAmplitude;
          if (Math.abs(startRect.left - endRect.left) > Math.abs(startRect.top - endRect.top)) {
            y += offset;
          } else {
            x += offset;
          }
        } else if (animationPath === 'arc') {
          const midX = (startRect.left + endRect.left) / 2;
          const midY = (startRect.top + endRect.top) / 2;
          const controlX = midX + (startRect.top - endRect.top) * 0.5;
          const controlY = midY - (startRect.left - endRect.left) * 0.5;

          x = Math.pow(1 - t, 2) * startRect.left + 2 * (1 - t) * t * controlX + Math.pow(t, 2) * endRect.left;
          y = Math.pow(1 - t, 2) * startRect.top + 2 * (1 - t) * t * controlY + Math.pow(t, 2) * endRect.top;

        } else if (animationPath === 'circular') {
          const centerX = (startRect.left + endRect.left) / 2;
          const centerY = (startRect.top + endRect.top) / 2;
          const radius = Math.sqrt(Math.pow(startRect.left - endRect.left, 2) + Math.pow(startRect.top - endRect.top, 2)) / 2;
          const startAngle = Math.atan2(startRect.top - centerY, startRect.left - centerX);
          const endAngle = Math.atan2(endRect.top - centerY, endRect.left - centerX);

          let currentAngle = lerp(startAngle, endAngle, t);

          x = centerX + radius * Math.cos(currentAngle);
          y = centerY + radius * Math.sin(currentAngle);

        } else if (animationPath === 'dogleg') {
          if (t < 0.5) {
            x = lerp(startRect.left, endRect.left, t * 2);
            y = startRect.top;
          } else {
            x = endRect.left;
            y = lerp(startRect.top, endRect.top, (t - 0.5) * 2);
          }
        }

        const currentWidth = lerp(startRect.width, 20, t);
        const currentHeight = lerp(startRect.height, 20, t);
        const currentOpacity = lerp(1, opacity, t);

        let transform = `translate(${x - startRect.left}px, ${y - startRect.top}px)`;

        if (animationStyle === 'rotate-shrink') {
          transform += ` rotate(${t * 360}deg)`;
        } else if (animationStyle === 'fade-slide') {
          transform += ` skewX(${t * 20}deg)`;
        }

        keyframes.push({
          transform: transform,
          width: `${currentWidth}px`,
          height: `${currentHeight}px`,
          opacity: currentOpacity
        });
      }

      const animation = clone.animate(keyframes, {
        duration: duration,
        easing: animationStyle === 'linear' ? 'linear' : (animationStyle === 'ease-in' ? 'ease-in' : 'ease-out'),
        fill: 'forwards'
      });

      animation.onfinish = () => {
        clone.remove();
      };
    });
  });
})();
